export enum CustomsScanModal {
  PACKAGE_ON_HOLD = "PACKAGE_ON_HOLD",
  MASTER_CARTON_ON_HOLD = "MASTER_CARTON_ON_HOLD",
  MASTER_CARTON_NOT_FOUND = "MASTER_CARTON_NOT_FOUND",
  MASTER_CARTON_BARCODE_INVALID = "MASTER_CARTON_BARCODE_INVALID",
  CUSTOMS_UNKNOWN_ERROR = "CUSTOMS_UNKNOWN_ERROR",
  TRACKING_CODE_NOT_FOUND = "TRACKING_CODE_NOT_FOUND",
  UNKNOWN_CUSTOMS_STATUS = "UNKNOWN_CUSTOMS_STATUS",
}
